import type { LanguageCode } from '@/config/languages';
import reviewState from './review-state.generated.json';

/**
 * Languages the browser's `navigator.languages` hint may pick on a first
 * anonymous visit.
 *
 * Rulings brief B14: a language without a named native reviewer is never
 * anyone's DEFAULT — it ships behind the switcher with the on-screen
 * "Machine-translated" banner. So the browser step of negotiation may only
 * resolve to a language whose SHELL namespaces are all `approved` in
 * `review-state.generated.json` (derived from `i18n/state/<code>.json` by
 * `scripts/i18n-review-state.mjs`). A namespace missing from the file is
 * `draft`, never assumed approved. English is always eligible. `?lang=` and
 * the stored preference are not filtered by this list, because the person
 * chose them.
 */
export const SHELL_NAMESPACES = ['common', 'nav', 'shell'] as const;

type ReviewMap = Record<string, Record<string, string>>;

export function browserEligible(state: ReviewMap = reviewState as ReviewMap): readonly LanguageCode[] {
  const eligible: LanguageCode[] = ['en'];
  for (const [code, byNamespace] of Object.entries(state)) {
    if (code === 'en') continue;
    if (SHELL_NAMESPACES.every((ns) => byNamespace?.[ns] === 'approved')) eligible.push(code as LanguageCode);
  }
  return eligible;
}
